import { SendbirdGroupChannel } from "./chat.types";
import { useWorkplaceWorker } from "../workers/WorkerDetails/useWorkplaceWorker";
import { SessionType } from "@src/modules/interface";
import { useSelector } from "react-redux";

interface UseChatWorkerQualificationsParams {
  workerId: string;
  workplaceId: string;
  currentChannel: SendbirdGroupChannel | undefined;
}

export function useChatWorkerQualifications(params: UseChatWorkerQualificationsParams) {
  const { workerId, workplaceId, currentChannel } = params;

  const {
    admin,
    adminUserId,
    user: { _id: workplaceUserId } = {},
  } = useSelector((state: SessionType) => state.session);

  const { workerDetails: worker, lastWorkedShift } = useWorkplaceWorker({
    workerId,
    workplaceId,
    workplaceUserId,
    admin,
    adminUserId,
  });

  const matchingQualifications = worker?.matchingFacilityQualifications ?? [];

  // Priority order for default qualification selection:
  // 1. Qualification from chat context (agentReq in metadata) if valid
  // 2. Worker's qualification from their last worked shift if valid
  // 3. Worker's preferred qualification if it matches facility
  // 4. First available matching qualification
  // 5. Worker's preferred qualification
  const defaultWorkerQualification =
    matchingQualifications.find(
      (qualification) => qualification === currentChannel?.metadata?.agentReq
    ) ??
    matchingQualifications.find((qualification) => qualification === lastWorkedShift?.agentReq) ??
    matchingQualifications.find((qualification) => qualification === worker?.qualification) ??
    matchingQualifications[0] ??
    worker?.qualification;

  return { defaultWorkerQualification, matchingQualifications, lastWorkedShift };
}
